/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';

const IdbHandler = {
	/**
	 * @description Configuration for the database
	 */
	config: {
		dbName: 'OfficePulseDB',
		version: 1,
		stores: {
			companies: {
				storeName: 'companies', // idb store name
				keyPath: 'ID', // idb store keyPath
				apiEndpoint: '/wp-json/office-pulse-api/v1/get-all-companies', // api endpoint
				lastUpdateKey: '_op_companies_last_update', // used for localStorage
				updateField: 'companies_table_last_update', // saved as wp_option
			},
			// users: {
			// 	storeName: 'users',
			// 	keyPath: 'ID',
			// 	apiEndpoint: '/wp-json/office-pulse-api/v1/get-all-users',
			// 	lastUpdateKey: '_op_users_last_update',
			// 	updateField: 'users_table_last_update',
			// },
		},
	},

	loadingCounter: 0,

	/**
	 * @description Initialize
	 */
	init: function () {
		this.showLoader();

		this.openDatabase().then(() => {
			const storeKeys = Object.keys(this.config.stores);

			const loadPromises = storeKeys.map((storeKey) => this.checkAndStoreData(storeKey));
			Promise.all(loadPromises).then(() => {
				this.hideLoader();
			});
		});
	},

	/**
	 * @description Show the loader
	 */
	showLoader: function () {
		document.body.classList.add('loading-idb');
	},

	/**
	 * @description Hide the loader
	 */
	hideLoader: function () {
		document.body.classList.remove('loading-idb');
		document.body.classList.add('idb-loaded');
	},

	/**
	 * @description Open or create IndexedDB
	 */
	openDatabase: function () {
		return new Promise((resolve, reject) => {
			const request = indexedDB.open(IdbHandler.config.dbName, IdbHandler.config.version);

			request.onupgradeneeded = function (event) {
				const db = event.target.result;
				const { stores } = IdbHandler.config;

				for (const key in stores) {
					const storeConfig = stores[key];
					if (!db.objectStoreNames.contains(storeConfig.storeName)) {
						db.createObjectStore(storeConfig.storeName, { keyPath: storeConfig.keyPath });
					}
				}
			};

			request.onsuccess = function (event) {
				IdbHandler.db = event.target.result;
				resolve(IdbHandler.db);
			};

			request.onerror = function (event) {
				reject('Error opening IndexedDB: ' + event.target.errorCode);
			};
		});
	},

	/**
	 * @description Clear a specific store
	 */
	clearStore: function (storeName) {
		return new Promise((resolve, reject) => {
			const transaction = IdbHandler.db.transaction(storeName, 'readwrite');
			const store = transaction.objectStore(storeName);

			const clearRequest = store.clear();

			clearRequest.onsuccess = function () {
				console.log(`${storeName} store cleared.`);
				resolve();
			};

			clearRequest.onerror = function (event) {
				console.error(`Error clearing ${storeName} store:`, event.target.error);
				reject(event.target.error);
			};
		});
	},

	/**
	 * @description Store data in a specific store
	 */
	storeData: function (storeName, data) {
		return new Promise((resolve, reject) => {
			const transaction = IdbHandler.db.transaction(storeName, 'readwrite');
			const store = transaction.objectStore(storeName);

			data.forEach((item) => {
				store.put(item);
			});

			transaction.oncomplete = function () {
				console.log(`Data stored successfully in ${storeName}.`);
				resolve();
			};

			transaction.onerror = function (event) {
				console.error(`Error storing data in ${storeName}:`, event.target.error);
				reject(event.target.error);
			};
		});
	},

	/**
	 * @description Fetch data from the API
	 */
	fetchDataFromAPI: function (endpoint) {
		return fetch(endpoint, {
			method: 'GET',
			// headers: {
			// 	'Content-Type': 'application/json',
			// 	'Authorization': `Bearer ${window.apiSettings.token}`,
			// },
		})
			.then((response) => response.json())
			.catch((error) => {
				console.error(`Error fetching data from ${endpoint}:`, error);
				throw error;
			});
	},

	/**
	 * @description Check if data is up-to-date and update IndexedDB
	 */
	checkAndStoreData: function (storeKey) {
		this.loadingCounter++;

		const storeConfig = IdbHandler.config.stores[storeKey];
		if (!storeConfig) {
			console.error(`Store configuration for ${storeKey} not found.`);
			this.loadingCounter--;
			return Promise.resolve();
		}

		const lastUpdate = document.querySelector(`input[name="${storeConfig.updateField}"]`) ? document.querySelector(`input[name="${storeConfig.updateField}"]`).value : '';
		console.log(`Server last update for ${storeKey}:`, lastUpdate);

		const storedUpdate = localStorage.getItem(window.origin + storeConfig.lastUpdateKey);
		console.log(`Stored last update for ${storeKey}:`, storedUpdate);

		if (storedUpdate !== lastUpdate) {
			localStorage.setItem(window.origin + storeConfig.lastUpdateKey, lastUpdate);

			return IdbHandler.fetchDataFromAPI(storeConfig.apiEndpoint)
				.then((data) => IdbHandler.clearStore(storeConfig.storeName)
					.then(() => IdbHandler.storeData(storeConfig.storeName, data[storeConfig.storeName]))
				)
				.finally(() => {
					this.loadingCounter--;
					if (this.loadingCounter === 0) {
						this.hideLoader();
					}
				});
		} else {
			console.log(`${storeKey} data is already up-to-date in IndexedDB.`);
			this.loadingCounter--;
			if (this.loadingCounter === 0) {
				this.hideLoader();
			}
			return Promise.resolve();
		}
	},
};

export default IdbHandler;
